import { Table, Button, Space, Card, Skeleton } from 'antd';
import { userdata } from '../typing/table_typing';
import  { Component } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { Link } from 'react-router-dom';

export interface TableThingyMainProps{
  data:{
    user:userdata[],
  }
  view:
  {
    loaded:boolean,
    autorefresh:boolean,
  }
  onLoadRequested:()=>void;

}

interface TableThinyViewInnerState{filteredInfo:any, sortedInfo:any}

export class TableThingyView extends Component<TableThingyMainProps, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps){
      super(props);
      this.state = {
        filteredInfo: null,
        sortedInfo: null,
      };
    }

  

    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 2000);
      
      // this.props.onButtonClicked();
    }
   
    handleChange = (pagination:any, filters:any, sorter:any) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };   

      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setSeveritySort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'sev10',
          },
        });
      };

      setIPSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'target',
          },
        });
      };
    

render(){
  let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    const columns = [
      {
        title: 'Target',
        dataIndex: ['uuid','target'],
        key: 'target',
        width:'150px',
        filters: [
        ],
        filteredValue: filteredInfo.name || null,
        onFilter: (value:any, record:any) => record.username.includes(value),
        sorter: (a:any, b:any) => a.target.length - b.target.length,
        sortOrder: sortedInfo.columnKey === 'target' && sortedInfo.order,
        ellipsis: false,
        render: (text:any , row:any) => (
          <Link to={"/Ziel/"+row.uuid}> {row.target} </Link>
        ),
      },
      {
        title: 'Sev. 10',
        dataIndex: 'severity10',
        key: 'severity10',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev10 - b.sev10,
        sortOrder: sortedInfo.columnKey === 'sev10' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 9',
        dataIndex: 'severity9',
        key: 'severity9',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev9 - b.sev9,
        sortOrder: sortedInfo.columnKey === 'sev9' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 8',
        dataIndex: 'severity8',
        key: 'severity8',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev8 - b.sev8,
        sortOrder: sortedInfo.columnKey === 'sev8' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 7',
        dataIndex: 'severity7',
        key: 'severity7',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev7 - b.sev7,
        sortOrder: sortedInfo.columnKey === 'sev7' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 6',
        dataIndex: 'severity6',
        key: 'severity6',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev6 - b.sev6,
        sortOrder: sortedInfo.columnKey === 'sev6' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 5',
        dataIndex: 'severity5',
        key: 'severity5',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev5 - b.sev5,
        sortOrder: sortedInfo.columnKey === 'sev5' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 4',
        dataIndex: 'severity4',
        key: 'severity4',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev4 - b.sev4,
        sortOrder: sortedInfo.columnKey === 'sev4' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 3',
        dataIndex: 'severity3',
        key: 'severity3',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev3 - b.sev3,
        sortOrder: sortedInfo.columnKey === 'sev3' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 2',
        dataIndex: 'severity2',
        key: 'severity2',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev2 - b.sev2,
        sortOrder: sortedInfo.columnKey === 'sev2' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 1',
        dataIndex: 'severity1',
        key: 'severity1',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev1 - b.sev1,
        sortOrder: sortedInfo.columnKey === 'sev1' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Sev. 0',
        dataIndex: 'severity0',
        key: 'severity0',
        filters: [
          { text: '0', value: 0 },
          { text: '>0', value: !0 },
        ],
        sorter: (a:any, b:any) => a.sev0 - b.sev0,
        sortOrder: sortedInfo.columnKey === 'sev0' && sortedInfo.order,
        ellipsis: true,
      },
    ];


    if (this.props.view.loaded === false)
    {
      return (
        <div>
          <Skeleton active />
          </div>
      )    
    }
    else
    {
  return (
    <div>
      <Card title="Vulnerabilities" style={cardmargin}   hoverable styles={{ header: grayheader }}>
    <Space style={{ marginBottom: 16 }}>
      <Button onClick={this.setSeveritySort}>Sort Severity</Button>
      <Button onClick={this.setIPSort}>Sort IP</Button>
      <Button onClick={this.clearFilters}>Clear filters</Button>
      <Button onClick={this.clearAll}>Clear filters and sorters</Button>
    </Space>
    <Table columns={columns} dataSource={this.props.data.user} onChange={this.handleChange} />
    </Card>
    </div>
  )}
  }
}